import { ImageFrame, Img, Placeholder } from '../ImageFrame';
import type { SideImageProps } from './SideImage.types';

function SideImageBase({
  src,
  alt = '',
  overlayContent,
  onBack,
  backLabel,
  badge,
  mobileHeight,
  desktopHeight,
  sticky = true,
}: SideImageProps) {
  return (
    <ImageFrame
      sticky={sticky}
      onBack={onBack}
      backLabel={backLabel}
      overlayContent={overlayContent}
      badge={badge}
      mobileHeight={mobileHeight}
      desktopHeight={desktopHeight}
    >
      {src ? <Img src={src} alt={alt} loading="eager" /> : <Placeholder />}
    </ImageFrame>
  );
}

export const SideImage = Object.assign(SideImageBase, {
  Badge: ImageFrame.Badge,
});
